import { reportRemovable } from '@felix/domain';
import type { VoyageReport } from './types.js';

/**
 * Raporun kaldırılabilirliği arayüzde (ADR 0077 §3): yalnız seferin son akış raporu silinir ya
 * da iptal edilir. Kararı yine tek yazma yolu verir (`REPORT_NOT_LAST`); arayüz düğmeyi önceden
 * kapatır ve nedenini yazar. `reports`: seferin iptal edilmemiş raporları (taslaklar dahil).
 */
export function removableIn(reports: readonly VoyageReport[], id: string): boolean {
  return reportRemovable(
    reports
      .filter((r) => r.status !== 'void')
      .map((r) => ({ id: r.id, kind: r.kind, reportedAt: r.reportedAt, data: r.data })),
    id,
  );
}
